"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottlenecksAwsInteractor = void 0;
const interactors_1 = require("../../interactors");
require("./types");
require("./BottlenecksAwsLoadableModel");
class BottlenecksAwsInteractor extends interactors_1.SynchronizingInteractor {
    constructor(model, listener) {
        super(model);
        this.listener = listener;
        this.onHowToFixClose = () => {
            this.listener.setActiveHowToFixPage(null);
        };
        this.onHowToFixClick = (type) => {
            this.listener.setActiveHowToFixPage(type);
        };
        this.listener = listener;
    }
}
exports.BottlenecksAwsInteractor = BottlenecksAwsInteractor;
//# sourceMappingURL=BottlenecksAwsInteractor.js.map